export default __webpack_public_path__ + "static/media/amico.fc7b6a72.svg";